import { Loader } from 'lucide-react';

export function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="min-h-[300px] flex flex-col items-center justify-center gap-3 text-[var(--color-muted)]">
      <Loader className="animate-spin text-[var(--color-teal)]" size={28} />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <div className="to-card p-8 sm:p-10 text-center flex flex-col items-center gap-3" data-testid="empty-state">
      {Icon && (
        <div className="h-14 w-14 rounded-full bg-[rgba(13,140,140,0.10)] text-[#0B6F6F] flex items-center justify-center mb-1">
          <Icon size={24} />
        </div>
      )}
      <h3 className="font-display text-lg sm:text-xl font-semibold text-[var(--color-ink)]">{title}</h3>
      {body && <p className="text-sm text-[var(--color-muted)] max-w-md">{body}</p>}
      {action}
    </div>
  );
}
